export const FEDERATED_APP_CLIENT_ID = 'FEDERATED_APP_CLIENT_ID';
export const FEDERATED_OAUTH = 'FEDERATED_OAUTH';
export const FEDERATED_PATH = 'FEDERATED_PATH';